export default __webpack_public_path__ + "static/media/portfolio-hover-198.6496421c.jpg";